import React from 'react'
import { useNavigate } from 'react-router'
import { paths } from '@routes'
import styled from 'styled-components'
import { BaseWrapper, TOAST_TYPE } from '@base'
import { useDispatch, useSelector } from 'react-redux'
import { DRAWER_TYPES, MB_ROLES, strings } from '@constants'
import { useForceUpdate } from '@hooks'
import { toggleDrawer } from '@data/state/action/root'
import { isClient, isSuperAdmin } from 'src/utils/adminFilter'
import { getOrganisationByUser, getOrganisationKycData } from '@data'
import { showToast } from '@data/state/action'
import { Spacings } from '@styles'
import ImageWapper from './ImageWapper'

const Wapper = styled(BaseWrapper)`
	display: flex;
	flex-wrap: wrap;
	padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
	flex-direction: row;
	justify-content: center;
	align-items: stretch;
	flex: 4;
`
const ImageContaint = styled.div`
	padding: ${Spacings.SPACING_2B};
	width: ${({ ImageWidth }) => (ImageWidth ? ImageWidth : '33%')};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`
const Deeplinks = ({ DeeplinksData, ImageWidth, type = MB_ROLES.SALES }) => {
	const dispatch = useDispatch()
	const [forceUpdate, update] = useForceUpdate()
	const navigate = useNavigate()
	const user = useSelector((state) => state.getIn(['user', 'user']))

	const clickHandler = (item) => {
		if (type === MB_ROLES.SALES) {
			return dispatch(toggleDrawer(true, DRAWER_TYPES.SALES_REQUEST_FOR_CREDIT, { update, label: strings('request_credit') }))
		}

		if (isSuperAdmin(user.role)) {
			navigate(paths.admin_organisations)
		} else {
			getOrganisationByUser(user?.user_id)
				.then((orgRes) => {
					const organisationId = orgRes?.organisation_id
					if (!organisationId) throw new Error('Organisation not found')
					return getOrganisationKycData(organisationId)
				})
				.then((kycData) => {
					dispatch(
						toggleDrawer(true, DRAWER_TYPES.COMPLETE_YOUR_KYC, {
							kycData,
							adminView: isClient(user?.role),
							update,
						})
					)
				})
				.catch((error) => {
					dispatch(showToast(true, error.response.data.message, { type: TOAST_TYPE.ERROR }))
				})
		}
	}
	return (
		<Wapper>
			{DeeplinksData?.map((item, index) => (
				<ImageContaint key={index} ImageWidth={ImageWidth}>
					<ImageWapper
						icon={item?.icon}
						title={item?.title}
						disabled={true}
						href={item?.href}
						actionButton={item?.actionButton}
						onClick={() => clickHandler()}
					/>
				</ImageContaint>
			))}
		</Wapper>
	)
}

export default Deeplinks
